import React from 'react';
import AboutUsabout from '../pages/Aboutabout';
import Testimonialsabout from '../pages/Testimonialsabout';

const AboutUs = () => {
  return (
  <>
  
      <section
      className="breadcrumb-main pb-20 pt-14"
      style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
      <div className="section-shape section-shape1 top-inherit bottom-0"
        style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
      <div className="breadcrumb-outer">
        <div className="container ">
          <div className="breadcrumb-content text-center">
            <h1 className="mb-3">About Us</h1>
           
          </div>
        </div>
      </div>
      <div className="dot-overlay"></div>
    </section>

  
    <section
      className="about-us pt-6"
      style={{ backgroundImage: 'url(images/background_pattern.png)', backgroundPosition: 'bottom right' }}
    >
      <div className="container">
        <div className="about-image-box">
          <div className="row d-flex align-items-center justify-content-between">
            {/* Left Content */}
            <div className="col-lg-6 ps-4">
              <div className="about-content text-center text-lg-start">
                <h4 className="theme d-inline-block mb-0">Get To Know Us</h4>
                <h2 className="border-b mb-2 pb-1">Its all about Anand Krushi Paryatan Kendra.</h2>
                <p className="border-b mb-2 pb-2">
                  Anand Krushi Paryatan Kendra is a peaceful place in Pune started by Mr. Anand Thopate in 1995. He loves nature and wanted to share it with others. He made the place from scratch, turning it into a beautiful 40-acre spot full of plants and animals. Here, people can do lots of fun things. Nature lovers can go birdwatching or take walks with guides who know a lot about the local plants and animals. If you like adventure, you can try rock climbing or zip-lining in the scenic countryside. Anand Krushi Paryatan Kendra also cares about the environment. They built eco-friendly rooms and use renewable energy to power them. They also teach people about things like farming without chemicals and how to reduce waste. In 2013 and 2017, the Maharashtra Tourism Development Corporation awarded Anand Krushi Paryatan Kendra with prestigious awards for its outstanding contributions to eco-tourism and sustainable practices. These awards recognize the center's dedication to protecting the environment and promoting responsible tourism. The center doesn't just focus on tourists. They work with nearby villages, helping them with jobs and teaching new skills. They want everyone to benefit from eco-tourism. Anand Krushi Paryatan Kendra isn't just a place to visit; it's a symbol of caring for the Earth. It inspires people to love nature and protect it for the future. And as more people visit, they become part of the journey too,
                  <br />
                 
                </p>
                <div className="about-listing">
                  <ul className="d-flex justify-content-between">
                    <li><i className="icon-location-pin theme"></i> Tour Guide</li>
                    <li><i className="icon-briefcase theme"></i> Friendly Price</li>
                    <li><i className="icon-folder theme"></i> Reliable Tour Package</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-lg-6 mb-4 pe-4">
              <div className="about-image" style={{ animation: 'none', background: 'transparent' }}>
                <img src="images/travel.png" alt="Travel" />
              </div>
            </div>

            {/* Counter Section */}
            <div className="col-lg-12">
              <div className="counter-main w-75 float-start z-index3 position-relative">
                <div className="counter p-4 pb-0 box-shadow bg-white rounded mt-minus">
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                      <div className="counter-item border-end pe-4">
                        <div className="counter-content">
                          <h2 className="value mb-0 theme">30</h2>
                          <span className="m-0">Years Experiences</span>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                      <div className="counter-item border-end pe-4">
                        <div className="counter-content">
                          <h2 className="value mb-0 theme">13</h2>
                          <span className="m-0">Attractions</span>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                      <div className="counter-item border-end pe-4">
                        <div className="counter-content">
                          <h2 className="value mb-0 theme">5500</h2>
                          <span className="m-0">Happy Customers</span>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                      <div className="counter-item">
                        <div className="counter-content">
                          <h2 className="value mb-0 theme">13</h2>
                          <span className="m-0">Activities</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Counter */}
          </div>
        </div>
      </div>
      <div className="white-overlay"></div>
    </section>
    <AboutUsabout/>
    <Testimonialsabout/>
  </>
  );
};

export default AboutUs;
